export default {
  order: {
    statuses: {
      in_progress: '进行中',
      unpaid: '未支付',
      paid: '已支付',
      closed: '已关闭'
    }
  }
}
